import Vue from 'vue'
import Vuex from 'vuex'
import GLOBAL from '@/assets/js/global.js';
// import {getproductByIndex} from '@/data/getdata.js'
  
Vue.use(Vuex)
const key ='token'
const ua = {}

import {
  token_type,
  issn
} from '@/api/config';
 
const store = new Vuex.Store({
 state(){
   return{
     token:localStorage.getItem(token_type) ? localStorage.getItem(token_type):'',
     account : localStorage.getItem('account') ? JSON.parse(localStorage.getItem('account')):{},
     userinfo : localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')):{},
     login : (localStorage.getItem('userinfo') != '{}' && localStorage.getItem('userinfo')) ? true : false,
     task : 0,
     map : 0,
     form : {},
     fromType : '0',
     basket : {},
     ex_list : {},
     ticket : [],
     uid_pre : 0,
     Loading : false,
     team : {team: false, teamCode: null, teamNum: 0, applys: 0, member: [], applyList: []},
     flag : 0,
     score : 0,
   }
 },
  getters:{
    getSortage:function (state) {
      if(!state.token){
        state.token = localStorage.getItem(token_type)
      }
      return state.token
    }, 
    getaccount: function(state){
      state.account= localStorage.getItem('account') ? JSON.parse(localStorage.getItem('account')) : {}
      return state.account || {}
    },
    getlogin: function(state){
        state.login = parseInt(localStorage.getItem('login')) ? true : false;
        return state.login
    },
    getuserinfo: function(state){
      state.userinfo = localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')) : {}
      return state.userinfo
    },          
  },
  mutations:{
    $_setLoading : function (state,value){
      state.Loading = value;
   },    
   $_setStorage(state,value){
     state.token =value;
     localStorage.setItem(token_type,value)
   },
   $_setCode(state,value){
    state.code = value;
    localStorage.setItem("code",value)
    },
    $_setShare(state,value){
      state.share =value;
    },
    $_setMap(state,value){
      state.map =value;
    }, 
    $_setFlag(state,value){
      state.flag += value;
    },               
   $_setAccount(state,account_ua){
     state.account =account_ua
     localStorage.setItem("account",JSON.stringify(account_ua))
   },
   $_setLogin(state,value){
    state.login = value
    localStorage.setItem("login",value)
   },
   $_setAid(state,value){
    state.userinfo.areaId = value;
   },   
   $_setUserinfo(state,value){
    if(typeof value == 'undefined')return;
    state.userinfo = value
    localStorage.setItem("userinfo",JSON.stringify(value))
   },
   $_setUsertype(state,value){
    if(typeof value == 'undefined')return;
    state.account.userType= state.account.userType | value
   },
   $_setUserdata(state,value){
    if(typeof value == 'undefined')return;
    state.account.userData[value] = "1"
   },    
   $_setTask(state,value){
    if(typeof value == 'undefined')return;
    state.task = value;  
   },
   $_setRewardStatus(state,value){
    if(typeof value == 'undefined')return;

    state.task[0].giftRate = state.task[0].finishRate;
    if((state.account.uflag & 2) == 2)state.task[1].giftRate = state.task[1].finishRate;
   },
   $_setFinishRate(state,value){
    if(typeof value == 'undefined')return;

    state.task[0].finishRate = Math.floor(value / 100);
    if((state.account.uflag & 2) == 2){
      state.task[1].finishRate = Math.floor(value / 100);
    }
    //console.log(state.task);
   }, 
   $_setScore(state,value){
    if(typeof value == 'undefined')return;
    //state.account.score += parseInt(value)

    state.score += value
   },
   $_setToken(state,value){
    if(typeof value == 'undefined')return;
    state.token = value;
   },
   $_setFrom(state,value){
    if(typeof value == 'undefined')return;
    state.fromType = value;
   }, 
   $_setTeam(state,value){
    if(typeof value == 'undefined')return;
    state.team = value;
   },    
   $_setInviteCode(state,value){
    if(typeof value == 'undefined')return;
    state.userinfo.bindCode = value;
   },           
  },
})
export default store